import { Injectable } from '@angular/core';
import { SharedService, TRANSLATION_MAP } from '../shared';
import { IAzavistaGroupedFieldsComponentData, IField, IFieldIdWithOptions } from '@azavista/components/shared';
import { IProject, ProjectType } from '@azavista/servicelib';
import { IConfirmationDialogComponentData } from '../shared/confirmation-dialog/confirmation-dialog.interfaces';

@Injectable()
export class ProjectDataService {

    constructor(private sharedSvc: SharedService) {}

    async showDeleteConfirmation(projectType: ProjectType): Promise<IConfirmationDialogComponentData> {
        const title = projectType === ProjectType.project
            ? TRANSLATION_MAP.DELETE_PROJECT_DIALOG_TITLE: TRANSLATION_MAP.DELETE_PROJECT_TEMPLATE_DIALOG_TITLE;
        const areYouSure =  projectType === ProjectType.project
            ? TRANSLATION_MAP.DELETE_PROJECT_DIALOG_ARE_YOU_SURE: TRANSLATION_MAP.DELETE_PROJECT_TEMPLATE_DIALOG_ARE_YOU_SURE;
        return this.sharedSvc.showConfirmationDialog(
            this.sharedSvc.translate(title),
            [
                this.sharedSvc.translate(areYouSure),
                this.sharedSvc.translate(TRANSLATION_MAP.YOU_WONT_BE_ABLE_TO_RESTORE_DATA)
            ]
        );
    }

    createNewGroupData(fields: IField[], project?: IProject): IAzavistaGroupedFieldsComponentData {
        const entity = project || {} as IProject;
        const fieldsOptions: IFieldIdWithOptions[] = [];
        const result: IAzavistaGroupedFieldsComponentData = {
            expandPanels: true,
            editModeForAllFields: true,
            singleColumn: true,
            showActionButtons: true,
            fieldsWithEntity: {
                entity,
                fields: fields
            },
            disableAutoOrdering: true,
            fieldsOptions: fieldsOptions
        };
        return result;
    }
}
